export default __webpack_public_path__ + "static/media/hht1_home_img_EP20.f85da86e.png";